import routes from './routes';
import generic from '../constants/generic'
import routerNames from '../router/router-names';
import genericUtils from '@/shared/utils/generic.js';

import { createRouter, createWebHistory } from 'vue-router'

// Extract locale from url: /<LANG>/loan-enquiry/app/eligibility
const i = location.pathname.toLowerCase().indexOf(__webpack_public_path__);
const locale = location.pathname.substring(0, i);
let routerBasePath = locale + __webpack_public_path__;

const router = createRouter({
  history: createWebHistory(routerBasePath),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (to.matched.every((record, i) => from.matched[i] !== record))
      return { x: 0, y: 0 };
    }
    // leave scroll as it is by not returning anything
    // https://github.com/Microsoft/TypeScript/issues/18319

    return false    
  },
});

let isInitialNavigation = true;         // Flag to track initial navigation

router.beforeEach((to, from, next) => {
  const whitelist = [routerNames.Home, routerNames.DocPackUpload, routerNames.Payment];
  const requestedPath = to.name;

  if (isInitialNavigation && (  !whitelist.includes(requestedPath) ||
                                ( requestedPath == routerNames.Home && window._inputs == undefined || window._inputs.inputModule == undefined ) || 
                                ( requestedPath === routerNames.Payment && to.query.s == undefined ) )) {
    isInitialNavigation = false;        // Reset flag after first navigation
    genericUtils.redirectToStart();     // Block only on initial navigation (user entering URL) and not in-app navigation
  } else {
    isInitialNavigation = false;        // Reset flag after first navigation
    next();                             // Allow navigation normally for all other cases
  }
});

router.afterEach(() => {
  document.title = window != null && window._inputs != null && window._inputs.inputGlobal != null ? window._inputs.inputGlobal.cuName : `${generic.OpenModuleTitle}`;
});

export default router;
